import { HomeBuildingEffects } from '@zayan-erp/stores';
import { WarrantyEffects } from '@zayan-erp/stores';
import { SalesEffects } from '@zayan-erp/stores';

export const appEffects = [HomeBuildingEffects, WarrantyEffects, SalesEffects];
